import { isEmpty } from 'lodash-es';

export default class {
  constructor(element, step) {
    this.element = element;
    this.step = step;

    this.$maturityDay = $('#enrollment_maturity_day');
    this.$bankAccountId = $('#enrollment_bank_account_id');

    this.$maturityDay.on('change', () => this.updateStep());
    this.$bankAccountId.on('change', () => this.updateStep());

    this.updateStep();
  }

  updateStep() {
    this.step.valid = this.isValid();
    this.updateSummary();
  }

  updateSummary() {
    let summaryMessage = '';

    if (isEmpty(this.$maturityDay.val())) {
      summaryMessage += '<span class="font-red-flamingo"><i class="fas fa-exclamation-circle mr-1"></i> Vencimento é obrigatório.</span><br>';
    }

    if (isEmpty(this.$bankAccountId.val())) {
      summaryMessage += '<span class="font-red-flamingo"><i class="fas fa-exclamation-circle mr-1"></i> Conta Bancária é obrigatória.</span><br>';
    }

    this.step.updateSummary(summaryMessage);
  }

  isValid() {
    const maturityDayValid = !isEmpty(this.$maturityDay.val());
    const bankAccountIdValid = !isEmpty(this.$bankAccountId.val());

    return maturityDayValid && bankAccountIdValid;
  }
}